var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 2,
    fill: "white",
    stroke: "#9F1853",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.75H11.75C11.4185 18.75 11.1005 18.6183 10.8661 18.3839C10.6317 18.1495 10.5 17.8315 10.5 17.5V11.25C10.5 10.9185 10.6317 10.6005 10.8661 10.3661C11.1005 10.1317 11.4185 10 11.75 10H18C18.3315 10 18.6495 10.1317 18.8839 10.3661C19.1183 10.6005 19.25 10.9185 19.25 11.25V17.5C19.25 17.8315 19.1183 18.1495 18.8839 18.3839C18.6495 18.6183 18.3315 18.75 18 18.75ZM11.75 11.25V17.5H18V11.25H11.75Z",
    fill: "#9F1853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 15V17.5H21.75V15H24.25ZM24.25 13.75H21.75C21.4185 13.75 21.1005 13.8817 20.8661 14.1161C20.6317 14.3505 20.5 14.6685 20.5 15V17.5C20.5 17.8315 20.6317 18.1495 20.8661 18.3839C21.1005 18.6183 21.4185 18.75 21.75 18.75H24.25C24.5815 18.75 24.8995 18.6183 25.1339 18.3839C25.3683 18.1495 25.5 17.8315 25.5 17.5V15C25.5 14.6685 25.3683 14.3505 25.1339 14.1161C24.8995 13.8817 24.5815 13.75 24.25 13.75Z",
    fill: "#9F1853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 21.25V23.75H21.75V21.25H24.25ZM24.25 20H21.75C21.4185 20 21.1005 20.1317 20.8661 20.3661C20.6317 20.6005 20.5 20.9185 20.5 21.25V23.75C20.5 24.0815 20.6317 24.3995 20.8661 24.6339C21.1005 24.8683 21.4185 25 21.75 25H24.25C24.5815 25 24.8995 24.8683 25.1339 24.6339C25.3683 24.3995 25.5 24.0815 25.5 23.75V21.25C25.5 20.9185 25.3683 20.6005 25.1339 20.3661C24.8995 20.1317 24.5815 20 24.25 20Z",
    fill: "#9F1853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.25V23.75H15.5V21.25H18ZM18 20H15.5C15.1685 20 14.8505 20.1317 14.6161 20.3661C14.3817 20.6005 14.25 20.9185 14.25 21.25V23.75C14.25 24.0815 14.3817 24.3995 14.6161 24.6339C14.8505 24.8683 15.1685 25 15.5 25H18C18.3315 25 18.6495 24.8683 18.8839 24.6339C19.1183 24.3995 19.25 24.0815 19.25 23.75V21.25C19.25 20.9185 19.1183 20.6005 18.8839 20.3661C18.6495 20.1317 18.3315 20 18 20Z",
    fill: "#9F1853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationLegend);
export default __webpack_public_path__ + "static/media/applicationLegend.bea7556f3c509731fe724f5b875a316e.svg";
export { ForwardRef as ReactComponent };